import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth';

import PaymentLinkPage from './PaymentLinkPage';

const PaymentLinkRoute: FuseRouteItemType[] = [];

PaymentLinkRoute.push({
  path: 'payment-link/:id',
  element: <PaymentLinkPage />,
  auth: AUTH_ROLES.onlyGuest || AUTH_ROLES.user,
});

export default PaymentLinkRoute;

// http://localhost:3000/payment-link/6b8c77b6-212d-433e-b166-74d0007af86e
